import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import { injectIntl } from 'react-intl';
import { i18nIntl } from '../../lib/ep.js';

import CloseButtonPublic from './CloseButtonPublic';

import ActionLink from '../builder/ActionLink';
import LeveledHTMLText from './helpers/LeveledHTMLText.js';

const ESCAPE_KEY = 27;

const FloatingLayerPublic = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);

	const title = props?.title ?? false;

	const is_emulated_box = props?.is_emulated_box ?? false;
	const title_alignment = props?.title_alignment ?? false;
	const enable_close = props?.enable_close ?? true;
	const display_close_button = props?.display_close_button ?? true;
	const full_content = props?.full_content ?? false;
	const custom_back_button = props?.custom_back_button ?? false;
	const only_contents = props?.only_contents ?? false;
	const is_builder = props?.is_builder ?? false;
	const max_width = props?.max_width ?? false;
	const autotranslate = props?.autotranslate ?? true;

	const element_id = Math.round(100 * Math.random());

	const [ pos_styles, setPosStyles ] = useState((max_width) ? { maxWidth:max_width } : {});
	
	const handleKeyDown = (e) => {
		switch(e.keyCode) {
			case ESCAPE_KEY:
				manageBackButton();
				break;

			default:
				break;
		}
	};

	useEffect(() => {
		document.addEventListener("keydown", handleKeyDown);

		if(is_builder) {
			// calculate the position of the layer
			if(window.template == undefined || window.template == 'minimal') {
				setPosStyles({
					...pos_styles,
					marginTop:0,
					marginBottom:0,
					//top:`${(window.innerHeight / 2 - document.getElementById(`layer_contents_react_${element_id}`).offsetHeight / 2)}px`,
				});
			}
		}

		return () => {
			document.removeEventListener("keydown", handleKeyDown);
		};
	}, []);

	const manageBackButton = () => {
		const enable_behavior = props?.enable_behavior ?? false;
		if(is_builder && !enable_behavior) return;
		if(props.backButton != undefined) props.backButton();
	};

	let classname = props?.classname ?? 'gui_contextual_box';
	const classes = classname.split(" ");

	if(only_contents) classes.push('only_contents');

	if(props._class) {
		for(var i in props._class) classes.push(props._class[i]);
	}

	if(is_builder || is_emulated_box) classes.push('emulated_box awesome');
	classname = classes.join(' ');

	let element = document.getElementById('gui_modal_root_public');
	if(element == null) {
		element = document.createElement('div');
		element.id = 'gui_modal_root_public';
		element.classList.add('awesome');
		document.body.appendChild(element);
		element = document.getElementById('gui_modal_root_public');
	}

	const title_text = (title) ? ((typeof title === 'string' && autotranslate) ? i18n(title) : title) : false;

	const title_classes = ['box_title', 'hb_secondaryFont', 'original_color_item', 'gui_cutTextOnOverflow'];
	if(!display_close_button || !enable_close) title_classes.push('without_close');
	if(title_alignment && title_alignment != '') title_classes.push(`gui_${title_alignment}_aligned`);

	const content_classes = ['contents'];
	if(full_content) content_classes.push('full_content');

	return ReactDOM.createPortal(
		<div class={'gui_floating_layer_react' + ((is_builder) ? ' is_builder' : '')}>
			<div class="gui_layer_bg" onClick={() => manageBackButton()} />

			<aside id={`layer_contents_react_${element_id}`} class={classname} style={pos_styles}>
				{((custom_back_button) || (enable_close && display_close_button)) && (
					<header class="box_header">
						{(custom_back_button) && (
							<span class="custom_back_button">{custom_back_button}</span>
						)}

						{(enable_close && display_close_button) && (
							<CloseButtonPublic
								onClick={() => manageBackButton()}
							/>
						)}
					</header>
				)}

				<div class={content_classes.join(" ")} style={props.content_styles}>
					{(title) && (
						<LeveledHTMLText
							_class={{ other:'layer_title' }}
						>{title_text}</LeveledHTMLText>
					)}

					{props.children}
				</div>

				{(props.footer_buttons != undefined) && (
					<div class="cb_footer_buttons">
						<li class="continue_button flex_button this_button">
							{props.footer_buttons}
						</li>
					</div>
				)}
			</aside>
		</div>,
		element,
	);
}

export default injectIntl(FloatingLayerPublic);